<template>
  <div class="landing-container">
    <div class="welcome-card">
      <div class="discord-image">
        <img 
          class="header-img"
          :src="marketMovesLogo"
        />
      </div>
      <div class="welcome-message">
        <div class="welcome-message-text__1">
          <span>
            Welcome to Market Moves Option Alerts by Matt!
          </span>
        </div>
        <div class="welcome-message-text__2">
          <span>
            Login to discord below to access the dashboard.
          </span>
        </div>
        <br>
        <div class="welcome-message-text__3">
          <span>
            If you have not already, please follow instructions in the discord server to register your email into our system.
          </span>
        </div>
      </div>
    </div>
    <div class="welcome-card-footer">
      <div class="login-btn">
        <a
          href="https://us-central1-market-moves.cloudfunctions.net/app/api/auth/discord/"
        >
          <img
            class="btn-svg"
            :src="discordFullLogo"
          />
        </a>
      </div>
      </div>
  </div>
</template>

<script>
import marketMovesLogo from '@/assets/images/marketmoveslogo.png';
import discordFullLogo from '@/assets/images/discord-full-logo.svg';

export default {
  name: 'Landing',
  metaInfo: {
    title: 'Market Moves',
    titleTemplate: 'Market Moves - Landing'
  },
  data() {
    return {
      marketMovesLogo,
      discordFullLogo
    }
  },
  mounted() {
    if (this.$cookies.get('session_token')) {
      this.$router.push({ path: '/dashboard' });
    }
  }
}
</script>

<style scoped>
  .landing-container {
    width: 400px;
    height: 600px;
    background-color: #36393f;
    color: #f8f8f8;
    border-radius: 15px;
    text-transform: uppercase;
    margin: 0 auto;
  }

  .welcome-card {
    width: 100%;
    height: calc(100% - 20%)
  }
  
  .welcome-card-footer {
    width: 100%;
    height: calc(100% - 80%);
    background: #36393f;
    border-radius: 0 0 25px 25px;
    padding-top: 20px;
  }

  .discord-image {
    width: 120px;
    height: 120px;
    margin: 0 auto;
    padding-top: 12px;
    border: 1px #fff;
    margin-bottom: 15px;
  }

  .header-img {
    object-fit: cover;
    width: 100%;
    border-radius: 50%;
  }

  .welcome-message-text__1 {
    font-weight: 700;
    font-size: 32px;
    margin-bottom: 40px;
    padding-right: 12px;
    padding-left: 12px;
  }

  .welcome-message-text__2 {
    font-weight: 300;
    text-align: center;
    padding-right: 25px;
    padding-left: 25px;
  }

  .welcome-message-text__3 {
    font-weight: 300;
    text-align: center;
    padding-right: 25px;
    padding-left: 25px;
  }

  .login-btn-container {
    background: #23272A;
    width: 100%;
    height: 100%;
    padding-top: 20px;
  }

  .login-btn {
    background: #7289DA;
    border: #7289DA;
    border-radius: 15px;
    width: 50%;
    height: 50px;
    margin: 0 auto;
    margin-top: 20px;
  }
  
  .login-btn img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
</style>